import { Link } from "react-router-dom";
import { Search, ClipboardList, CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";

const STEPS = [
  { icon: Search, t: "Recherchez un centre", d: "Filtrez par réseau, ville ou code postal pour trouver un centre partenaire près de chez vous." },
  { icon: ClipboardList, t: "Remplissez votre demande", d: "Choisissez le motif, une date et vos coordonnées. Aucune information médicale n'est demandée." },
  { icon: CheckCircle2, t: "Confirmation par notre équipe", d: "Le centre étudie sa disponibilité, un administrateur d'Audition Expert confirme le rendez-vous." },
];

export default function HowItWorks() {
  return (
    <div>
      <section className="hero-bg py-20">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <div className="text-gold uppercase tracking-widest text-sm font-semibold">Comment ça marche</div>
          <h1 className="font-heading text-4xl sm:text-5xl text-primary-blue mt-3">Un parcours simple et transparent</h1>
          <p className="mt-6 text-lg text-slate-700 max-w-2xl">
            Audition Expert facilite votre prise de rendez-vous auprès de nos centres auditifs partenaires. Le service est
            entièrement <strong>gratuit</strong> et respecte votre confidentialité.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-3 gap-8">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div key={s.t} className="p-8 bg-white rounded-2xl border border-slate-100 card-lux" data-testid={`how-step-${i + 1}`}>
              <div className="w-14 h-14 rounded-xl bg-sky-blue flex items-center justify-center">
                <Icon size={26} className="text-primary-blue" />
              </div>
              <div className="mt-6 font-heading text-2xl text-primary-blue">Étape {i + 1}</div>
              <div className="mt-1 font-semibold text-lg text-slate-800">{s.t}</div>
              <p className="mt-3 text-slate-700 leading-relaxed">{s.d}</p>
            </div>
          );
        })}
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 pb-24">
        <div className="rounded-2xl bg-sky-blue/60 p-10 border border-primary-blue/10">
          <h2 className="font-heading text-2xl md:text-3xl text-primary-blue">Vos garanties</h2>
          <ul className="mt-6 space-y-3 text-slate-700">
            <li>• Bilan et devis gratuits chez nos centres partenaires.</li>
            <li>• Vos données ne sont transmises qu'au centre que vous avez sélectionné.</li>
            <li>• Aucun paiement n'a lieu sur Audition Expert.</li>
            <li>• Vous pouvez modifier ou annuler votre demande depuis votre espace client.</li>
          </ul>
          <div className="mt-8">
            <Link to="/prendre-rendez-vous">
              <Button className="btn-lg-senior bg-primary-blue text-white hover:bg-[#0a1d36]">
                Commencer ma demande <ArrowRight className="ml-2" size={18} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
